/**
 * CLI-to-Console Bridge Utility
 * 
 * Provides utilities for CLI workflows to generate console URLs and bridge to console surfaces
 */

const CONSOLE_BASE_URL = 'https://trustgate-27ddc.web.app';

export interface ConsoleUrlOptions {
  artifactId?: string;
  artifactType?: 'receipt' | 'bundle' | 'proof' | 'request' | 'artifact';
  artifactPath?: string;
}

/**
 * Generate a console URL for viewing an artifact in the artifact browser
 */
export function generateConsoleUrl(options: ConsoleUrlOptions): string {
  if (options.artifactId) {
    // Direct verification URL for receipts/proofs
    return `${CONSOLE_BASE_URL}/verify/${options.artifactId}`;
  }
  
  if (options.artifactPath) {
    // Artifact browser URL (would need to be implemented to accept path params)
    // For now, return to artifact browser home
    return `${CONSOLE_BASE_URL}/artifact-browser`;
  }
  
  // Default to console home
  return CONSOLE_BASE_URL;
}

/**
 * Format console URL output for CLI display
 */
export function formatConsoleUrlOutput(url: string, description?: string): string {
  const lines = [
    '',
    '--- Console View ---',
    description ? description : 'View in TrustGate Console:',
    url,
    '-------------------',
    ''
  ];
  return lines.join('\n');
}

/**
 * Generate and format console URL for CLI output
 */
export function addConsoleUrlToOutput(options: ConsoleUrlOptions, description?: string): string {
  const url = generateConsoleUrl(options);
  return formatConsoleUrlOutput(url, description);
}
